import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import { ModalTemplate } from "../modalTemplate";

import { LoaderOverlay } from "../../../component";
import { UploadSpinner } from "../../../component/Loader";

const UploadProjectIssuesModal = function({
  template = <ModalTemplate />,
  size = "lg",
  onClose = () => {},
  classes = "",
  isLoading = false,
  containerClass,
  ModalDialog,
  backdropClassName = "",
  centered,
  loadingPercent = 0,
  backdrop = "",
  dataTest = "modal",
  hideProgressbar
}) {
  return (
    <Modal
      show={true}
      size={size}
      dialogAs={ModalDialog}
      onHide={onClose}
      backdrop={backdrop}
      dialogClassName={containerClass}
      centered={centered}
      backdropClassName={backdropClassName}
      className={`modal-common-template ${classes}`}
      data-test={dataTest}
    >
      {template}
      {hideProgressbar ? null : (
        // <UploadSpinner
        //   loading={isLoading}
        //   className={"upload_spinner_container"}
        // />
        <LoaderOverlay loading={isLoading} loadingPercent={loadingPercent} />
      )}
    </Modal>
  );
};

export { UploadProjectIssuesModal };
